import React from 'react'
import Marquee from 'react-fast-marquee'
const BrandAreaOne = () => {
  return (
    <div className="about-area bg-gray pt-5 pb-5">
      <div className="container">
        <div className="client-slider">
          <Marquee gradient={false}>
            <div className="thumb" style={{ width: '230px' }}>
              <img src="/assets/img/client/navica.jpg" alt="img" />
            </div>
            <div className="thumb" style={{ width: '230px' }}>
              <img src="/assets/img/client/microsoft.jpg" alt="img" />
            </div>
            <div className="thumb" style={{ width: '230px' }}>
              <img src="/assets/img/client/capital-outsourcing.jpg" alt="img" />
            </div>
            <div className="thumb" style={{ width: '230px' }}>
              <img src="/assets/img/client/dw.jpg" alt="img" />
            </div>
            <div className="thumb" style={{ width: '280px' }}>
              <img src="/assets/img/client/dell.svg" alt="img" />
            </div>
            <div className="thumb" style={{ width: '230px' }}>
              <img src="/assets/img/client/se.jpg" alt="img" />
            </div>
          </Marquee>
        </div>
      </div>
    </div>
  )
}

export default BrandAreaOne
